// Due to VueTailwind being UMD, see https://github.com/vitejs/vite/issues/813
import TRichSelect from 'vue-tailwind/dist/t-rich-select'

// We have to use a shared settings object because if we register tailwind a second tim
// with different settings, it is ignored. There's probably a way to manually call
// Vue.component and pass in the settings, but this is easier and is what is documented.
const tailwindSettings = {
    't-rich-select': {
        component: TRichSelect,
        props: {
            fixedClasses: {
                wrapper: 'relative',
                buttonWrapper: 'inline-block relative w-full',
                selectButton: 'w-full grid text-left justify-between items-center pl-3 py-2 pr-8 text-black transition duration-100 ease-in-out border-b focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed',
                selectButtonLabel: 'block truncate',
                selectButtonPlaceholder: 'block truncate',
                selectButtonIcon: 'rounded flex flex-shrink-0 items-center justify-center absolute right-0 top-0 m-2 h-6 w-6 transition duration-100 ease-in-out fill-current h-3 w-3',
                selectButtonClearButton: 'rounded flex flex-shrink-0 items-center justify-center absolute right-0 top-0 m-2 h-6 w-6 transition duration-100 ease-in-out',
                selectButtonClearIcon: 'fill-current h-3 w-3',
                dropdown: 'absolute w-full z-10 -mt-1 absolute border rounded-b shadow-sm z-10',
                optionsList: 'overflow-auto',
                searchWrapper: 'inline-block w-full',
                searchBox: 'inline-block w-full',
                option: 'cursor-pointer',
                disabledOption: 'opacity-50 cursor-not-allowed',
                highlightedOption: 'cursor-pointer',
                selectedOption: 'cursor-pointer',
                selectedHighlightedOption: 'cursor-pointer',
                optionLabel: 'truncate block',
                // Remove the checkmark to indicate selection.  Another option (later) is to
                // create our own slot template so that we can add other styling that we want.
                selectedIcon: 'hidden'
                // selectedIcon: 'fill-current h-4 w-4'
            },
            classes: {
                wrapper: '',
                buttonWrapper: '',
                selectButton: 'bg-white border-gray-700',
                selectButtonLabel: '',
                selectButtonPlaceholder: 'text-gray-400',
                selectButtonIcon: 'hover:bg-primary hover:text-white text-black',
                selectButtonClearButton: 'hover:bg-primary hover:text-white text-black',
                selectButtonClearIcon: '',
                dropdown: 'bg-white border-gray-300',
                dropdownFeedback: 'pb-2 px-3 text-gray-400 text-sm',
                loadingMoreResults: 'pb-2 px-3 text-gray-400 text-sm',
                optionsList: '',
                searchWrapper: 'p-2 placeholder-gray-400',
                searchBox: 'px-3 py-2 bg-gray-50 text-sm rounded border focus:outline-none border-gray-400',
                optgroup: 'text-primary text-opacity-75 uppercase text-xs py-1 px-2 font-semibold',
                option: '',
                disabledOption: '',
                highlightedOption: 'bg-primary bg-opacity-75 text-white',
                selectedOption: 'bg-primary text-white',
                selectedHighlightedOption: 'bg-primary text-white',
                optionContent: 'flex justify-between items-center px-3 py-2',
                optionLabel: '',
                selectedIcon: '',
                enterClass: 'opacity-0',
                enterActiveClass: 'transition ease-out duration-100',
                enterToClass: 'opacity-100',
                leaveClass: 'opacity-100',
                leaveActiveClass: 'transition ease-in duration-75',
                leaveToClass: 'opacity-0'
            }
        }
    }
}

export default tailwindSettings;